import { render, staticRenderFns } from "./borrowerDetails.vue?vue&type=template&id=0ba6a9ec&scoped=true"
import script from "./borrowerDetails.vue?vue&type=script&lang=js"
export * from "./borrowerDetails.vue?vue&type=script&lang=js"
import style0 from "./borrowerDetails.vue?vue&type=style&index=0&id=0ba6a9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba6a9ec",
  null
  
)

export default component.exports